// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React, {useCallback} from 'react';
import {useHistory} from 'react-router-dom';
import cn from 'classnames';
import {Button} from '../button';
import * as cns from './tabs.module.less';

function Item({
    fill_width,
    to,
    ico,
    on_click,
    value,
    is_active,
    label,
    size='s',
})
{
    const handle_click = useCallback(()=>{
        on_click?.(value);
    }, [value, on_click]);
    return <Button className={cn(cns.tab, fill_width&&cns.tab__wide,
      is_active ? cns.tab__active : cns.tab__inactive)} ico={ico}
      on_click={handle_click} href={to} size={size}
      color_scheme={is_active ? 'primary' : 'tertiary'}
      filled>
      {label}
    </Button>;
}

function Tabs_base({items, className, fill_width, render_item, key_prop}){
    return <ul className={cn(cns.root, fill_width&&cns.root__wide, className)}>
      {items.map(item=>{
          return <li className={cn(cns.item, fill_width&&cns.item__wide)}
            key={item[key_prop]}>
            {render_item(item)}
          </li>;
      })}
    </ul>;
}

export function Routed_tabs({
    items,
    size,
    className,
    fill_width,
})
{
    const {location} = useHistory();
    const {pathname, search} = location;
    const render_item = useCallback(item=>{
        const is_active = pathname.startsWith(item.to);
        const to = item.to+search;
        return <Item to={to} label={item.label} ico={item.ico}
          is_active={is_active} fill_width={fill_width} size={size}/>;
    }, [fill_width, pathname, search, size]);
    return <Tabs_base className={className} items={items} key_prop="to"
      fill_width={fill_width} render_item={render_item}/>;
}

export function Tabs({
    items,
    size,
    className,
    active_value,
    on_activate,
    fill_width,
})
{
    const render_item = useCallback(item=>{
        return <Item value={item.value} on_click={on_activate}
          label={item.label} is_active={item.value==active_value}
          ico={item.ico} fill_width={fill_width} size={size}/>;
    }, [fill_width, active_value, on_activate, size]);
    return <Tabs_base className={className} items={items} key_prop="value"
      fill_width={fill_width} render_item={render_item}/>;
}
